import React, { useState, useCallback, useMemo } from 'react';
import { useLanguage } from '../../locales/LanguageProvider.js';
import { useLocation } from 'react-router-dom';
import logo from '../../assets/img/logo/logo.svg';
import trFlag from '../../assets/img/icon/tr.png';
import enFlag from '../../assets/img/icon/en.png';
import arFlag from '../../assets/img/icon/ar.png';

const Header = () => {
  const { Localizer, changeLanguage, cult } = useLanguage();
  const t = (key) => Localizer(key, 'header');
  const location = useLocation();
  const currentPath = location.pathname;

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobileLangDropdownOpen, setMobileLangDropdownOpen] = useState(false);

  const isActive = useCallback((path) =>
    currentPath === path || (path !== '/' && currentPath.startsWith(path)),
    [currentPath]
  );

  const toggleMobileLangDropdown = useCallback(() => {
    setMobileLangDropdownOpen(!isMobileLangDropdownOpen);
  }, [isMobileLangDropdownOpen]);

  const handleMobileLanguageChange = useCallback((lang) => {
    changeLanguage(lang);
    setMobileLangDropdownOpen(false);
  }, [changeLanguage]);

  return (
    <header className="header-area header-transparent">
      {/* =================================================================
          DESKTOP HEADER (Masaüstü Başlık)
          ================================================================= */}
      <div className="main-header d-none d-lg-block">
        {/* ... Masaüstü header kodunun geri kalanı aynı ... */}
        <div className="header-top bdr-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="welcome-message">
                  <p>{t("Huzur Aksesuar'a Hoş Geldiniz")}</p>
                </div>
              </div>
              <div className="col-lg-6 text-right">
                <div className="header-top-settings">
                  <ul className="nav justify-content-end">
                    <li className="language">
                      <span>{t('Dil')}:</span>
                      <img
                        src={cult === 'tr' ? trFlag : cult === 'en' ? enFlag : arFlag}
                        alt="flag"
                        style={{ marginLeft: '5px' }}
                      />
                      <ul className="dropdown-list">
                        <li className={cult === 'en' ? 'active' : ''} onClick={() => changeLanguage('en')}>
                          <a role="button"><img src={enFlag} alt="flag" /> English</a>
                        </li>
                        <li className={cult === 'tr' ? 'active' : ''} onClick={() => changeLanguage('tr')}>
                          <a role="button"><img src={trFlag} alt="flag" /> Türkçe</a>
                        </li>
                        <li className={cult === 'ar' ? 'active' : ''} onClick={() => changeLanguage('ar')}>
                          <a role="button"><img src={arFlag} alt="flag" /> Arabic</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-main-area">
          <div className="header-middle-area">
            <div className="container">
              <div className="header-middle-inner">
                <div className="row align-items-center">
                  <div className="col-lg-4"></div>
                  <div className="col-lg-4 text-center">
                    <a href="/"><img src={logo} alt="logo" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header-meny-style-2 sticky">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="main-menu-area">
                    <div className="main-menu menu-style-2">
                      <nav className="desktop-menu">
                        <ul>
                          <li className={isActive('/') ? 'active' : ''}><a href="/">{t('Anasayfa')}</a></li>
                          <li className={isActive('/about') ? 'active' : ''}><a href="/about">{t('Hakkımızda')}</a></li>
                          <li className={isActive('/products') ? 'active' : ''}>
                            <a href="/products">{t('Ürünler')} <i className="fa fa-angle-down"></i></a>
                            <ul className="megamenu dropdown">
                              <li className="mega-title">
                                <a href="/products?mainct=0">{t('Mutfak')}</a>
                                <ul>
                                  <li><a href="/products?cat=2">{t('Kiler Grubu')}</a></li>
                                  <li><a href="/products?cat=3">{t('Tezgah Altı Grubu')}</a></li>
                                  <li><a href="/products?cat=4">{t('Köşe Dolabı Grubu')}</a></li>
                                </ul>
                              </li>
                              <li className="mega-title">
                                <ul>
                                  <li><a href="/products?cat=5">{t('Set Arası Grubu')}</a></li>
                                  <li><a href="/products?cat=6">{t('Dolap içi Raf Grubu')}</a></li>
                                  <li><a href="/products?cat=7">{t('Çok Amaçlı Kolon Grubu')}</a></li>
                                </ul>
                              </li>
                              <li className="mega-title">
                                <a href="/products?mainct=1">{t('Yatak Odası')}</a>
                                <ul><li><a href="/products?cat=8">{t('Gardrop Grubu')}</a></li></ul>
                              </li>
                              <li className="mega-title">
                                <a href="/products?mainct=2">{t('Banyo')}</a>
                                <ul><li><a href="/products?cat=9">{t('Banyo Grubu')}</a></li></ul>
                              </li>
                            </ul>
                          </li>
                          <li className={isActive('/videos') ? 'active' : ''}><a href="/videos">{t('Videolar')}</a></li>
                          <li className={isActive('/contact') ? 'active' : ''}><a href="/contact">{t('İletişim')}</a></li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =================================================================
          MOBILE HEADER (Mobil Başlık)
          ================================================================= */}
      <div className="mobile-header d-lg-none d-md-block sticky">
        {/* ... Mobil üst bar ... */}
        <div className="container">
          <div className="mobile-main-header">
            <div className="mobile-logo">
              <a href="/">
                <img src={logo} alt="logo" />
              </a>
            </div>
            <div className="mobile-menu-toggler">
              <div className="mobile-menu-btn">
                <div className="off-canvas-btn" onClick={() => setMobileMenuOpen(true)}>
                  <i className="lnr lnr-menu"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Off-canvas menü */}
        <div className={`off-canvas-wrapper ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="off-canvas-overlay" onClick={() => setMobileMenuOpen(false)}></div>
          <div className="off-canvas-inner-content">
            <div className="btn-close-off-canvas" onClick={() => setMobileMenuOpen(false)}>
              <i className="fa fa-close"></i>
            </div>
            <div className="off-canvas-inner">
              <div className="mobile-menu">
                {/* ... mobil menü linkleri ... */}
                <ul>
                  <li className={isActive('/') ? 'active' : ''}><a href="/" rel="noopener">{t('Anasayfa')}</a></li>
                  <li className={isActive('/about') ? 'active' : ''}><a href="/about" rel="noopener">{t('Hakkımızda')}</a></li>
                  <li className={isActive('/products') ? 'active' : ''}><a href="/products" rel="noopener">{t('Ürünler')}</a></li>
                  <li className={isActive('/videos') ? 'active' : ''}><a href="/videos" rel="noopener">{t('Videolar')}</a></li>
                  <li className={isActive('/contact') ? 'active' : ''}><a href="/contact" rel="noopener">{t('İletişim')}</a></li>
                  <div className="mobile-settings">
                    <ul className="nav">
                      {/* DEĞİŞİKLİK BURADA: 'dropup' sınıfı eklendi */}
                      <li className="mobile-top-dropdown dropup">
                        <span className="dropdown-toggle" onClick={toggleMobileLangDropdown}>
                          {t('Dil')}
                        </span>
                        <div className={`dropdown-menu ${isMobileLangDropdownOpen ? 'show' : ''}`}>
                          <a className="dropdown-item" onClick={() => handleMobileLanguageChange('tr')}>
                            <img src={trFlag} alt="TR" style={{ width: 20, marginRight: 8 }} />
                            Türkçe
                          </a>
                          <a className="dropdown-item" onClick={() => handleMobileLanguageChange('en')}>
                            <img src={enFlag} alt="EN" style={{ width: 20, marginRight: 8 }} />
                            English
                          </a>
                          <a className="dropdown-item" onClick={() => handleMobileLanguageChange('ar')}>
                            <img src={arFlag} alt="AR" style={{ width: 20, marginRight: 8 }} />
                            Arabic
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;